import React, { useState, useContext, createContext, useEffect } from "react";
import { ProviderServices } from "../services/Provider_Services";
import { useClientCity } from "./useClientCity";
import { useLanguage } from "./useLanguage";

// ** Utils Imports
const bestSellersContext = createContext();

export function ProviderBestSellers({ children }) {
  const bestSellers = useProviderBestSellers();
  return (
    <bestSellersContext.Provider value={bestSellers}>
      {children}
    </bestSellersContext.Provider>
  );
}

export const useBestSellers = () => {
  return useContext(bestSellersContext);
};

function useProviderBestSellers() {
  const { language } = useLanguage();
  const {clientCity} = useClientCity()

  // ** State
  const [bestSellers, setBestSellers] = useState({
    items: [],
    loading: true,
    error: false
  });

  // ** Get Best Sellers
  const getBbestSellers = () => {
    setBestSellers((prev) => ({ ...prev, loading: true }));
    ProviderServices.getRate(() => {})
      .then((res) => {
        const { data } = res;
        if (Array.isArray(data.data)) {
          setBestSellers((prev) => ({ ...prev, items: [...data.data] }));
        }
      })
      .catch((error) => {
        setBestSellers((prev) => ({ ...prev, error: true }));
      })
      .finally(() => {
        setBestSellers((prev) => ({ ...prev, loading: false }));
      });
  };

  useEffect(() => {
    if (clientCity && Object.keys(clientCity).length > 0) {
      if (clientCity.id !== 0) {
        getBbestSellers();
      }
    }

    return () => {};
  }, [language,clientCity]);

  // Return State
  return {
    bestSellers,
    getBbestSellers
  };
}
